// tokens.ts — shared design tokens for hero-particles bundle

export const FONT = {
  /** Single source for font-family — use TEXT_STYLE for everything else. */
  family: "'Public Sans', system-ui, sans-serif",
};

export const COLOR = {
  text:         "rgba(255,255,255,0.82)",
  textDim:      "rgba(255,255,255,0.35)",
  textSubtle:   "rgba(255,255,255,0.5)",
  textFull:     "#fff",
  surface:      "#080808",
  border:       "rgba(255,255,255,0.12)",
  borderSubtle: "rgba(255,255,255,0.08)",
  chipBg:       "rgba(255,255,255,0.07)",
  chipBgHover:  "rgba(255,255,255,0.13)",
  placeholder:  "rgba(255,255,255,0.06)",
  inputText:    "rgba(255,255,255,0.45)",
  msgBg:        "rgba(255,255,255,0.08)",
};

export const RADIUS = {
  pill:  "100px",
  modal: "24px",
  card:  "12px",
};

export const TRANSITION = {
  color: "color 0.15s ease",
  fade:  "opacity 0.15s ease",
};

// ── Named text styles ─────────────────────────────────────────────────────────
// Each entry is a complete composite — edit values here; the type sandbox at
// http://localhost:5173/type.html reflects changes instantly via Vite HMR.

export const TEXT_STYLE = {
  // Editorial / hero
  headline:   { size: "32px", weight: "300", lineHeight: "1.1",  tracking: "-0.01em" },
  subheading: { size: "20px", weight: "300", lineHeight: "1.3",  tracking: "0"       },

  // UI body
  bodyLarge:  { size: "18px", weight: "300", lineHeight: "1.65", tracking: "0.01em"  },
  body:       { size: "16px", weight: "100", lineHeight: "1.85", tracking: "0.05em"  },
  bodySmall:  { size: "14px", weight: "300", lineHeight: "1.65",  tracking: "0.15px"  },

  // Labels / metadata
  label:      { size: "20px", weight: "800", lineHeight: "1",    tracking: "0.1em"   },
  eyebrow:    { size: "14px", weight: "300", lineHeight: "1",    tracking: "0.12em"  },
  tab:        { size: "12px", weight: "300", lineHeight: "1",    tracking: "0.2em"  },

  // Interactive
  chip:       { size: "14px", weight: "100", lineHeight: "1",    tracking: "0.05em"  },
  inputText:  { size: "14px", weight: "100", lineHeight: "1.85",  tracking: "1px"  },
  inputLabel: { size: "10px", weight: "500", lineHeight: "1",    tracking: "0.1em"   },

  // Modal UI
  modalTitle: { size: "16px", weight: "800", lineHeight: "1.2",  tracking: ".03em"       },
} as const;

/**
 * Apply a named text style to an element.
 * Sets font properties via Object.assign (non-destructive — existing cssText
 * is preserved) and stamps data-text-style="<key>" so DevTools inspection
 * immediately reveals which token is in use.
 *
 *   applyTextStyle(el, "body");
 *   // → el.style.fontFamily/fontSize/fontWeight/lineHeight/letterSpacing set
 *   // → el.dataset.textStyle === "body"
 */
export function applyTextStyle(
  el: HTMLElement,
  key: keyof typeof TEXT_STYLE,
): void {
  const s = TEXT_STYLE[key];
  Object.assign(el.style, {
    fontFamily:    FONT.family,
    fontSize:      s.size,
    fontWeight:    s.weight,
    lineHeight:    s.lineHeight,
    letterSpacing: s.tracking,
  });
  el.dataset.textStyle = key;
}
